import React from 'react';
import PropTypes from 'prop-types';
import { useIncomeCategoryGroupData } from 'Hooks/useIncomeCategoryGroupData';
import { GroupTotalValueCard } from 'Components/ComponentLibrary/Molecules/GroupTotalValueCard';

const LABEL_TO_INCOME_GROUP = {
  'Earned income': 'active',
  'Passive income': 'passive',
};

const ActivePassiveIncomeCard = ({
  label,
  value,
}) => {
  const {
    getIncomeCategoryGroupIcon,
  } = useIncomeCategoryGroupData();

  return (
    <GroupTotalValueCard label={label} value={value} icon={getIncomeCategoryGroupIcon(LABEL_TO_INCOME_GROUP[label])} />
  );
};

ActivePassiveIncomeCard.defaultProps = {};

ActivePassiveIncomeCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export { ActivePassiveIncomeCard };
